import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { FC, useState, MouseEvent } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { AdRoutes } from "../../../../constants/ad-routes";
import { generateRoute } from "ui";

export type ActionMenuProps = {
  id: string | null;
  onDeleteRegion: (id: string | null) => void;
  onChangeServiceTime: (id: string | null) => void;
  onResequenceRoute: (id: string | null) => void;
};

const ActionMenu: FC<ActionMenuProps> = ({
  id,
  onDeleteRegion,
  onResequenceRoute,
  onChangeServiceTime,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const resequenceRoute = () => {
    onResequenceRoute(id);
    handleClose();
  };

  const editRegionDetails = () => {
    navigate(
      generateRoute(AdRoutes.editRegionDetails, {
        regionId: id!,
      }),
      { replace: true },
    );
    handleClose();
  };

  const changeServiceTime = () => {
    onChangeServiceTime(id);
    handleClose();
  };

  const handleDeleteRegion = () => {
    onDeleteRegion(id);
    handleClose();
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        sx={{
          padding: "0px",
        }}
      >
        <MoreVertIcon sx={{ width: "20px", height: "20px" }} />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          key="1"
          onClick={resequenceRoute}
          data-testid="resequence-route"
        >
          Resequence route
        </MenuItem>
        <MenuItem
          key="2"
          onClick={editRegionDetails}
          data-testid="edit-region-details"
        >
          Edit region Details
        </MenuItem>
        <MenuItem
          key="3"
          onClick={changeServiceTime}
          data-testid="change-service-time"
        >
          Change service time
        </MenuItem>
        <MenuItem
          key="4"
          onClick={handleDeleteRegion}
          data-testid="delete-region"
        >
          Delete region
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default ActionMenu;
